import { IRemoveAllConfirm } from '../../types/removeAllConfirm';
import { TReduxActions } from '../../types/redux';
import { REMOVE_ALL_CONFIRM_SET_VISIBLE } from '../../constants/actionTypes/removeAllConfirm';

const defaultState = {
  isVisible: false,
};

export function removeAllConfirmReducer(state: IRemoveAllConfirm = defaultState, action: TReduxActions) {
  switch (action.type) {
    case REMOVE_ALL_CONFIRM_SET_VISIBLE:
      return {
        ...state,
        isVisible: action.visible,
      };

    default:
      return state;
  }
}
